export default (theme) => ({
    canvas: {
        borderRadius: 4,
        display: 'block',
        width: '100%',
    },
    canvasActive: {},
    canvasWrapper: {
        flex: 1,
        minWidth: 0,
    },
    playButton: {
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        fontSize: 24,
        height: 24,
        width: 24,
    },
    root: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        width: '100%',
    },
    timeIndicator: {
        ...theme.typography.body,
        color: theme.colors.utility.textPrimary,
        flexShrink: 0,
        lineHeight: 1,
        marginLeft: 4,
        width: 40,
        textAlign: 'center',
    },
});
